module.exports = __webpack_public_path__ + "static/media/calender.29e90b31.svg";